import request from '@/utils/request'

export function login (data) {
  return request({
    url: `/platform/login`,
    method: 'post',
    data
  })
}
export function logout () {
  return request({
    url: `/platform/logout`,
    method: 'get'
  })
}
// 刷新accesstoken
export function refreshToken () {
  return request({
    url: `/platform/refreshToken`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js